module.exports = __webpack_public_path__ + "img/erp-logos_0024_odoo.3af9a191.jpg";